/**
 * Returns the currently active (focused) element,
 * drilling down through shadow DOMs if necessary.
 */
export const getDeepActiveElement = (root: Document | ShadowRoot = document): HTMLElement | null => {
  let active = root.activeElement;

  while (active?.shadowRoot && active.shadowRoot.activeElement) {
    active = active.shadowRoot.activeElement;
  }

  return active as HTMLElement | null;
};
